import styled from 'styled-components';
import { WaringModal } from '../../../modal/WaringModal';
import { ImageUtils } from '../../../../utils/ImageUtils';
import { goToTournament } from '../../../../utils';
import { useTextVariant } from '../../../../hook/useTextVariant';
import { PROGRESS_TICKET_CONSTANTS, getCongratsText } from '../../../../constants/progressTicket';
import { ProgressTicketCommonProps } from '../ProgressTicket';

export const ProgressTicketPc = ({
  goOnlineTab,
  goMainEventTab,
  ticketCnt,
  isActiveTicket,
  showWarningModal,
  setShowWarningModal,
  hasTicketNum,
}: ProgressTicketCommonProps) => {
  const { getText } = useTextVariant(PROGRESS_TICKET_CONSTANTS, false);

  return (
    <>
      <Container>
        <ImgContainer>
          <QuestionIcon onClick={() => setShowWarningModal(true)} />
          <TicketImg
            src={isActiveTicket ? ImageUtils.TicketActivePc : ImageUtils.TicketInActivePc}
            alt="ParticipateInfo"
          />
        </ImgContainer>
        <CountContainer>
          <TopInfo>
            <CountCnt>
              {ticketCnt}
              <CountUnit>장</CountUnit>
            </CountCnt>
            <RemainContainer>
              <RemainText>{getText('remainText')}</RemainText>
            </RemainContainer>
            <RemainSubText>{getText('remainSubText')}</RemainSubText>
          </TopInfo>

          {isActiveTicket ? (
            <BottomInfo>
              <CongratsText>{getText('congratsText')}</CongratsText>
              <CongratsSubText>{getCongratsText(hasTicketNum || 0, false)}</CongratsSubText>
              <br />
              <CongratsSubText>{getText('congratsSubText2')}</CongratsSubText>
            </BottomInfo>
          ) : (
            <BottomInfo>
              <NeedTicketSubTitle>{getText('needTicketSubTitle')}</NeedTicketSubTitle>
              <NeedTicketText>{getText('needTicketText')}</NeedTicketText>
              <NeedTicketSubText>{getText('needTicketSubText')}</NeedTicketSubText>
            </BottomInfo>
          )}
        </CountContainer>
      </Container>
      <BottomTabContainer>
        {isActiveTicket ? (
          <GoMainEventBtn onClick={goMainEventTab}>{getText('goMainEventBtn')}</GoMainEventBtn>
        ) : (
          <>
            <CheckParticipateBtn onClick={goOnlineTab}>
              {getText('checkParticipateBtn')}
            </CheckParticipateBtn>
            <GoTournamentBtn onClick={goToTournament}>{getText('goTournamentBtn')}</GoTournamentBtn>
          </>
        )}
      </BottomTabContainer>
      <WaringModal visible={showWarningModal} close={() => setShowWarningModal(false)} />
    </>
  );
};

const TopInfo = styled.div`
  flex-shrink: 0;
  height: 270px;
  background-color: transparent;
  border-radius: 8px;
  width: 380px;
  padding-top: 20px;
`;

const BottomInfo = styled.div`
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: transparent;
  border-radius: 8px;
  width: 210px;
`;

const ImgContainer = styled.div`
  position: relative;
`;

const TicketImg = styled.img`
  height: 273.28px;
  width: 589.824px;
  cursor: pointer;
`;

const Container = styled.div`
  position: relative;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  margin-top: 72px;
  align-items: center;
  justify-content: center;
  padding-bottom: 130px;
`;

const CountContainer = styled.div`
  position: absolute;
  top: 0;
  text-align: center;
  display: flex;
  width: 589.824px;
`;

const RemainContainer = styled.div`
  margin: 0 auto;
  margin-bottom: 9px;
  border-top: 1.5px solid rgba(0, 0, 0, 0.5);
  background: rgba(0, 0, 0, 0.1);
  padding-top: 2px;
  width: 230px;
  height: 32px;
`;

const RemainText = styled.h3`
  font-weight: 800;
  letter-spacing: -0.02em;
  color: rgba(0, 0, 0, 0.7);
  font-size: 16px;
  line-height: 22px;
`;

const RemainSubText = styled.h4`
  color: rgba(0, 0, 0, 0.5);
  text-align: center;
  font-size: 16px;
  font-weight: 500;
  line-height: 22px;
  letter-spacing: -0.96px;

  span {
    font-weight: 700;
  }
`;

const NeedTicketText = styled.h3`
  color: #000;
  text-align: center;
  font-size: 20px;
  font-weight: 600;
  line-height: 27px;
  letter-spacing: -0.8px;
  margin-bottom: 20px;
`;

const NeedTicketSubText = styled.h4`
  color: rgba(0, 0, 0, 0.5);
  text-align: center;
  font-size: 16px;
  font-weight: 500;
  line-height: 22px;
  letter-spacing: -0.64px;
  margin-bottom: 15px;
`;

const NeedTicketSubTitle = styled(NeedTicketSubText)`
  font-weight: 900;
`;

const CountCnt = styled.p`
  font-weight: bold;
  font-size: 96px;
  line-height: 140px;
`;

const CountUnit = styled.span`
  font-size: 30px;
  line-height: 32px;
  margin-left: 10px;
`;

const QuestionIcon = styled.div`
  position: absolute;
  cursor: pointer;
  z-index: 1;
  background-image: url(${ImageUtils.QuestionIcon});
  width: 30px;
  height: 30px;
  right: 220px;
  top: 10px;
  background-size: contain;
`;

const BottomTabContainer = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 10;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #262524;
  height: 96px;
`;

const CheckParticipateBtn = styled.button`
  cursor: pointer;
  border-radius: 125px;
  background: rgba(169, 31, 82, 0.85);
  backdrop-filter: blur(25px);
  width: 184px;
  height: 70px;
  margin-right: 10px;
  color: #fff;
  text-align: center;
  text-shadow: 0 1px 0 rgba(0, 0, 0, 0.5);
  font-size: 24px;
  font-weight: 900;
  letter-spacing: -0.96px;
`;

const GoTournamentBtn = styled.button`
  height: 70px;
  width: 346px;
  cursor: pointer;
  border-radius: 125px;
  background: rgba(139, 0, 67, 0.85);
  backdrop-filter: blur(25px);
  color: #fff;
  text-align: center;
  text-shadow: 0 1px 0 rgba(0, 0, 0, 0.5);
  font-size: 24px;
  font-weight: 900;
  letter-spacing: -0.96px;
`;

const GoMainEventBtn = styled.button`
  height: 70px;
  width: 400px;
  cursor: pointer;
  border-radius: 125px;
  background: rgba(139, 0, 67, 0.85);
  backdrop-filter: blur(25px);
  font-weight: 900;
  font-size: 21px;
  line-height: 28px;
  letter-spacing: -0.04em;
  color: #ffffff;
`;

const CongratsText = styled.h3`
  color: #d2006d;
  text-align: center;
  font-size: 24px;
  font-weight: 600;
  line-height: normal;
  letter-spacing: -0.96px;
  margin-bottom: 26px;
`;

const CongratsSubText = styled.h4`
  color: #840053;
  text-align: center;
  font-size: 16px;
  font-weight: 500;
  line-height: 20px;
  letter-spacing: -0.64px;

  span {
    color: #000;
    text-decoration-line: underline;
  }
`;
